import * as core from '../../../../../../../core'
import * as changeImpacts from '../change-impacts'

export const RESOURCE = {
  payload: {
    alias: 'dashboard',
    appAlias: changeImpacts.RESOURCE.payload.alias,
    description: 'Explore an overview of the change impacts for this client',
    display: {
      isMain: true,
      position: 2,
    },
    name: 'Dashboard',
    page: { alias: 'dashboard' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
